import { render, staticRenderFns } from "./tabs-Support.vue?vue&type=template&id=aba3abac&scoped=true&"
import script from "./tabs-Support.vue?vue&type=script&lang=js&"
export * from "./tabs-Support.vue?vue&type=script&lang=js&"
import style0 from "./tabs-Support.vue?vue&type=style&index=0&id=aba3abac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba3abac",
  null
  
)

export default component.exports